import React from 'react';
import { WebsiteName } from '../../App';
import HeroPage from '../Hero/HeroPage';
import ContactForm from '../Sections/ContactForm';
import MarketplaceSection from '../Sections/MarketplaceSection';

const Contact = () => {
    document.title = "About | " + WebsiteName;

    return (
        <>
            <HeroPage title="Get in touch"></HeroPage>
            <main>
                <section className="contact" id="contact">
                    <div className="container">
                        <ContactForm></ContactForm>
                    </div> {/* Container */}
                </section> {/* Contact */}

                <MarketplaceSection></MarketplaceSection>
            </main>
        </>
    );
};

export default Contact;